import CollapseIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandIcon from "@mui/icons-material/ExpandMoreRounded";
import { Button, type ButtonProps } from "@mui/material";

interface Props {
  expanded: boolean;
  expandButtonText?: string;
  collapseButtonText?: string;
  buttonColor?: ButtonProps["color"];
  onClick: () => void;
}

const ShowMoreLessButton = ({ expanded, onClick, expandButtonText, collapseButtonText, buttonColor }: Props) => {
  return (
    <Button
      variant="text"
      color={buttonColor}
      endIcon={expanded ? <CollapseIcon /> : <ExpandIcon />}
      sx={{ p: 0 }}
      onClick={onClick}
    >
      {expanded ? collapseButtonText || "Show less" : expandButtonText || "Show more"}
    </Button>
  );
};

export default ShowMoreLessButton;
